import script from "./FullSizeButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FullSizeButton.vue?vue&type=script&setup=true&lang=js"

import "./FullSizeButton.vue?vue&type=style&index=0&id=780cb9fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-780cb9fc"]])

export default __exports__